export default __webpack_public_path__ + "static/media/ic_close.01bd53ad.svg";